export default __webpack_public_path__ + "static/media/alien.ff965427.gif";